import request from '../utils/request'
import axios from 'axios'

/**
 * 获取采购单列表（内勤端）
 */
export function getPurchaseOrderList(params) {
  return request({
    url: '/internal/purchase/list',
    method: 'get',
    params
  })
}

/**
 * 获取采购单详情（内勤端）
 */
export function getPurchaseOrderDetail(id) {
  return request({
    url: `/internal/purchase/${id}`,
    method: 'get'
  })
}

/**
 * 创建采购单（内勤端）
 */
export function createPurchaseOrder(data) {
  return request({
    url: '/internal/purchase',
    method: 'post',
    data
  })
}

/**
 * 更新采购单（内勤端）
 */
export function updatePurchaseOrder(data) {
  return request({
    url: '/internal/purchase',
    method: 'put',
    data
  })
}

/**
 * 删除采购单（内勤端）
 */
export function deletePurchaseOrder(id) {
  return request({
    url: `/internal/purchase/${id}`,
    method: 'delete'
  })
}

/**
 * 导出采购单列表为Excel（内勤端）
 */
export function exportPurchaseOrderList(params) {
  const baseURL = process.env.VUE_APP_BASE_API || 'http://localhost:8086'
  const token = localStorage.getItem('accessToken')
  
  return axios({
    url: `${baseURL}/internal/purchase/export`,
    method: 'get',
    params,
    responseType: 'blob',
    headers: {
      'Authorization': token ? `Bearer ${token}` : ''
    },
    timeout: 60000
  }).then(response => {
    const contentType = response.headers['content-type'] || response.headers['Content-Type'] || ''
    if (contentType.includes('application/json')) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.onload = () => {
          try {
            const errorData = JSON.parse(reader.result)
            reject(new Error(errorData.msg || errorData.message || '导出失败'))
          } catch (e) {
            reject(new Error('导出失败：服务器返回了无效的响应'))
          }
        }
        reader.onerror = () => reject(new Error('导出失败：无法读取服务器响应'))
        reader.readAsText(response.data)
      })
    }
    return response.data
  }).catch(error => {
    if (error.response) {
      const { data, status, headers } = error.response
      const contentType = headers['content-type'] || headers['Content-Type'] || ''
      
      if (data instanceof Blob) {
        return new Promise((resolve, reject) => {
          const reader = new FileReader()
          reader.onload = () => {
            try {
              const text = reader.result
              const errorData = JSON.parse(text)
              reject(new Error(errorData.msg || errorData.message || '导出失败'))
            } catch (e) {
              if (contentType.includes('application/json')) {
                reject(new Error('导出失败：无法解析服务器响应'))
              } else {
                reject(new Error(`导出失败：HTTP ${status}`))
              }
            }
          }
          reader.onerror = () => reject(new Error('导出失败：无法读取服务器响应'))
          reader.readAsText(data)
        })
      }
      
      if (contentType.includes('application/json')) {
        const errorMsg = data.msg || data.message || `导出失败：HTTP ${status}`
        return Promise.reject(new Error(errorMsg))
      }
    }
    
    if (error.message && error.message.includes('Network Error')) {
      return Promise.reject(new Error('网络错误，请检查网络连接'))
    }
    
    throw error
  })
}

